up.on('ypsilon_gtm_data_update', function (event) {
  if (window.dataLayer && event.ypsilonGtmData) {
    event.ypsilonGtmData.forEach(data => window.dataLayer.push(data))
  }
})
